import request from '@/utils/request'

/**
 * 获取权限组列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回权限组列表
 */
export function listPrivilegeGroup(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup/listPrivilegeGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加权限组
 * @param {Object} data 权限组数据
 * @returns {Promise} 返回操作结果
 */
export function savePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup/savePrivilegeGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新权限组
 * @param {Object} data 权限组数据
 * @returns {Promise} 返回操作结果
 */
export function updatePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup/updatePrivilegeGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除权限组
 * @param {Object} data 删除参数
 * @returns {Promise} 返回操作结果
 */
export function deletePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup/deletePrivilegeGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}